<template>
    <b-field class="autocomplete-input-container-comparison" :class="{'show-icon': !isFetching}" :addons="false">
        <b-autocomplete
            v-model="autocompleteTerms"
            :data="autocompleteProductsList"
            :placeholder="$t('write_machine_name')"
            :size="'is-large '+(isFetching ? 'is-loading' : '')"
            ref="autocomplete"
            :keep-first="true"
            :open-on-focus="true"
            @typing="getAsyncProductList"
            @select="option => autocompleteSelectProduct(option)"
            rounded
        >
            <template slot="empty">
                <template v-if="autocompleteTerms && autocompleteTerms.length < minCharCount">{{ $t("please_specify_at_least_x_characters", {count: minCharCount}) }}</template>
                <template v-else-if="isFetching">{{ $t("search_in_progress") }}</template>
                <template v-else>{{ $t("no_results_for_this_search_in_speccheck_database") }}</template>
            </template>
            <template slot-scope="props">
                <div class="machine-option">
                    <span class="model-name"><strong>{{ props.option['Model'] }}</strong> {{ props.option['Tier'] }}</span>
                    <span class="brand-name">{{ props.option['Manufacturer'].toLowerCase() }}</span>
                    <span class="action-plus-minus-button" :class="isPlusOrMinus(props.option['Machine_ID'])"></span>
                </div>
            </template>
        </b-autocomplete>
        <span class="icon-search" :class="brandColor"></span>
    </b-field>
</template>

<script>
    import { mapState } from 'vuex'
    import machineService from "@/services/speccheck/machine";
    import {triggerTrackingEvent} from "@/common/helpers";

    export default {
        name: 'AutocompleteMachineComparison',
        props: {
            selectedProducts: {
                type: Array,
                default: () => []
            },
            prefillData: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                autocompleteTerms: '',
                timeout: null,
                minCharCount: 3,
                autocompleteProductsList: [],
                isFetching: false
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
        },
        mounted() {
          if (this.prefillData) {
            this.autocompleteTerms = this.prefillData
            this.getAsyncProductList(this.autocompleteTerms);
          }
        },
        methods: {
            getAsyncProductList(terms) {
                this.$emit('updateAutocompleteTerms', terms);
                clearTimeout(this.timeout);
                this.timeout = setTimeout(()=> {
                    this.autocompleteProductsList = []
                    if (terms.length < this.minCharCount)
                        return

                    this.isFetching = true

                    let onlyTier = this.$store.state.settings.region === 'R1' ? '4,5' : '2,3,4,5';

                    if(this.selectedProducts.length > 0 && parseInt(this.selectedProducts[0]['Tier_ID']) > 0)
                        onlyTier = parseInt(this.selectedProducts[0]['Tier_ID'])

                    machineService.search({
                        s: terms.replace(/\s/g, ''),
                        tids: onlyTier,
                        // exmanids: (this.selectedProducts.length > 0 ? 56 : null)
                    })
                    .then((response) => {
                        let results = response.data.data;
                        results.sort(function(a, b){
                            if(a['Model'] < b['Model']) { return -1; }
                            if(a['Model'] > b['Model']) { return 1; }
                            return 0;
                        })
                        results = results.filter(x => x['Machine_ID'] !== 'null')
                        this.autocompleteProductsList = results;
                    })
                    .finally(() => this.isFetching = false);
                }, 500);
            },
            autocompleteSelectProduct(option){
                /*gtag('event', 'click_autocompare_product', {
                    'event_category': 'click',
                    'event_label': `Clic sur un produit au niveau de l'autocomplétion dans la comparaison : ${option['Manufacturer']} - ${option['Model']}`
                });*/

                // triggerTrackingEvent('click_autocompare_product', 'click', `Clic sur un produit au niveau de l'autocomplétion dans la comparaison : ${option['Manufacturer']} - ${option['Model']}`)
                this.$emit('productSelected', option)
            },
            isPlusOrMinus(machineId){
                if(this.selectedProducts.find(x => x['Machine_ID'] === machineId))
                    return 'minus'
                else
                    return 'plus'
            },
            speccheckTierLabelFromTierId(tierId){
                const tierList = [
                    {
                        id: 1,
                        label: 'Tier 1',
                    },
                    {
                        id: 2,
                        label: 'Tier 2',
                    },
                    {
                        id: 3,
                        label: 'Tier 3',
                    },
                    {
                        id: 4,
                        label: 'Interim Tier 4',
                    },
                    {
                        id: 5,
                        label: 'Tier 4 Final',
                    }
                ]

                let findTier = tierList.find(x => x.id === parseInt(tierId));

                if(findTier)
                    return findTier.label
            }
        }
    }
</script>

<style lang="scss">
    .autocomplete-input-container-comparison {
        position: relative;

        @media #{$mq_phone} {
            margin-left: 20px;
            margin-right: 20px;
        }

        &.show-icon {
            [class^="icon-"], [class*=" icon-"] {
                display: inline-block;
            }
        }

        .input {
            padding-right: 45px;
        }

        [class^="icon-"], [class*=" icon-"] {
            display: none;
            position: absolute;
            z-index: 2;
            top: 50%;
            margin-top: -9px;
            right: 18px;
            font-size: 17px;
        }

        .machine-option {
            position: relative;

            .model-name {
                display: block;
            }
            .brand-name {
                color: $medium-grey;
                text-transform: capitalize;
            }

            .action-plus-minus-button {
                position: absolute;
                top: 50%;
                right: -30px;
                margin-top: -17px;
            }
        }
    }
</style>
